import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { ValueStack } from '../components/ValueStack';
import { TargetAudienceSection } from '../components/TargetAudienceSection';
import { AuthoritySection } from '../components/AuthoritySection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-white flex flex-col w-full overflow-x-hidden font-opensans" data-id="element-258">
      <UrgencyBar data-id="element-259" />
      <HeroSection data-id="element-260" />
      <PainSection data-id="element-261" />
      <RevelationSection data-id="element-262" />
      <ValueStack data-id="element-263" />
      <TargetAudienceSection data-id="element-264" />
      <AuthoritySection data-id="element-265" />
      <GuaranteeSection data-id="element-266" />
      <PricingSection data-id="element-267" />
      <FAQSection data-id="element-268" />
      <Footer data-id="element-269" />
    </main>;
}